import React from 'react';
import {Toast} from "react-bootstrap";

const myToast = (props) => {
  var backgroundColor = (props.isError)? "#ffc0c0" : "white";

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
    >
      <Toast
        onClose={props.hideClicked}
        style={{
          position: 'fixed',
          top: "1em",
          right: "1em",
          width: "250px",
          backgroundColor: backgroundColor
        }}
      >
        <Toast.Header>
          <strong className="mr-auto">{props.heading}</strong>
        </Toast.Header>
        <Toast.Body>{props.body}</Toast.Body>
      </Toast>
    </div>
  )
};

export default myToast;